import { matchEnv } from "./utils/matcher";
const FlagDefinitions = {
    Authority: {
        local: {
            flag: "on",
        },
        development: {
            flag: "on",
        },
        production: {
            flag: "on",
        },
    },
    QuickSightUserByTenant: {
        // QS User resource is charged $3 per user, month.
        // So disable it in local and dev env in default.
        // Be sure to remove the QS user(s) in dev env when you have completed your development.
        local: {
            flag: "off",
        },
        development: {
            flag: "off",
        },
        production: {
            flag: "on",
        },
    },
    OfficeGroups: {
        local: {
            flag: "some",
            tenantSlugs: ["demo3", "ascend-unsou", "akita-inc2"],
        },
        development: {
            flag: "on",
        },
        production: {
            flag: "some",
            tenantSlugs: ["demo3", "ascend-unsou", "akita-inc2"],
        },
    },
};
export class CoreFeatureFlags {
    static check(feature, tenantSlug) {
        const flag = matchEnv(FlagDefinitions[feature]);
        switch (flag.flag) {
            case "on":
                return true;
            case "off":
                return false;
            case "some":
                return flag.tenantSlugs.includes(tenantSlug);
        }
    }
}
//# sourceMappingURL=feature-flags.js.map